import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RadioCircle } from '@components/radio-button';
import { useFormContext } from 'react-hook-form';
import { HrFlexContainer } from '@components/styles/hr-styles';
import { Checkbox } from '@components/form/checkbox';
import { useTranslationWithPrefix } from '@/i18n/hooks';
import { optionsValues } from './constants';

const OptionsList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
`;

export const OptionsGroupWithCheckbox = (props) => {
  const { name, label, options, disabled, isOptionDisabled, hideOptions } = props;

  const { t } = useTranslationWithPrefix('requestVacancies.requestTemplate.form.stepOne.fields');
  const { register, getValues, setValue } = useFormContext();

  const settedValue = getValues(name);
  const isSectionDisabled = settedValue === '0';
  const checkboxData = {
    name: name === 'area' ? 'areaApprovalRequired' : 'subareaApprovalRequired',
    label: name === 'area' ? t('areaApprove.label') : t('subAreaApprove.label')
  };

  const onHandleCheckboxChange = (event) => {
    const selectedValue = parseInt(event.target.value);

    const setCheckBoxAsDisabled = selectedValue === optionsValues.DISABLED;
    if (setCheckBoxAsDisabled) {
      setValue(checkboxData.name, false);
    }
  };

  return (
    <HrFlexContainer flexDirection='column'>
      <HrFlexContainer justifyContent='space-between'>
        {label}
        {!hideOptions && (
          <OptionsList>
            {options.map((option) => (
              <RadioCircle
                key={option.value}
                name={name}
                text={option.label}
                value={option.value}
                checked={option.value === settedValue}
                register={register}
                onChange={onHandleCheckboxChange}
                disabled={disabled || isOptionDisabled(option.value)}
              />
            ))}
          </OptionsList>
        )}
      </HrFlexContainer>
      <Checkbox
        label={checkboxData.label}
        name={checkboxData.name}
        disabled={disabled || isSectionDisabled}
        register={register}
        defaultChecked={false}
      />
    </HrFlexContainer>
  );
};

OptionsGroupWithCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  disabled: PropTypes.bool,
  isOptionDisabled: PropTypes.func,
  hideOptions: PropTypes.bool
};

OptionsGroupWithCheckbox.defaultProps = {
  disabled: false,
  isOptionDisabled: () => false,
  hideOptions: false
};
